// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ClaimTransmissionStatus,
    ClaimTransmissionStatusFromJSON,
    ClaimTransmissionStatusToJSON,
    ProviderClaimPayment,
    ProviderClaimPaymentFromJSON,
    ProviderClaimPaymentToJSON,
    ProviderDentalClaim,
    ProviderDentalClaimFromJSON,
    ProviderDentalClaimToJSON,
    ProviderDocument,
    ProviderDocumentFromJSON,
    ProviderDocumentToJSON,
    ProviderInstitutionalClaim,
    ProviderInstitutionalClaimFromJSON,
    ProviderInstitutionalClaimToJSON,
    ProviderPayerSubscriber,
    ProviderPayerSubscriberFromJSON,
    ProviderPayerSubscriberToJSON,
    ProviderProfessionalClaim,
    ProviderProfessionalClaimFromJSON,
    ProviderProfessionalClaimToJSON,
    ProviderSubscriberPatient,
    ProviderSubscriberPatientFromJSON,
    ProviderSubscriberPatientToJSON,
    TransmissionType,
    TransmissionTypeFromJSON,
    TransmissionTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderClaimTransmission
 */
export interface ProviderClaimTransmission {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    id?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    externalId?: string;
    /**
     * The X12 837 document
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    x12?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ClaimTransmissionStatus>}
     * @memberof ProviderClaimTransmission
     */
    statuses?: Array<ClaimTransmissionStatus>;
    /**
     * 
     * OpenAPI data type: {TransmissionType}
     * @type {TransmissionType}
     * @memberof ProviderClaimTransmission
     */
    type?: TransmissionType;
    /**
     * The payer assigned internal control number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    payerIcn?: string;
    /**
     * The clearinghouse payer id the claim was transmitted to.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    clearinghousePayerId?: string;
    /**
     * The payer subscriber id the claim was transmitted for.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    payerSubscriberId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderPayerSubscriber}
     * @type {ProviderPayerSubscriber}
     * @memberof ProviderClaimTransmission
     */
    payerSubscriber?: ProviderPayerSubscriber;
    /**
     * The subscriber patient id the claim was transmitted for.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    subscriberPatientId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderSubscriberPatient}
     * @type {ProviderSubscriberPatient}
     * @memberof ProviderClaimTransmission
     */
    subscriberPatient?: ProviderSubscriberPatient;
    /**
     * The professional id this payment is associated with.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    professionalId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderProfessionalClaim}
     * @type {ProviderProfessionalClaim}
     * @memberof ProviderClaimTransmission
     */
    professional?: ProviderProfessionalClaim;
    /**
     * The institutional id this payment is associated with.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    institutionalId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderInstitutionalClaim}
     * @type {ProviderInstitutionalClaim}
     * @memberof ProviderClaimTransmission
     */
    institutional?: ProviderInstitutionalClaim;
    /**
     * The dental id this payment is associated with.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    dentalId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderDentalClaim}
     * @type {ProviderDentalClaim}
     * @memberof ProviderClaimTransmission
     */
    dental?: ProviderDentalClaim;
    /**
     * The nynf3 id this payment is associated with.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    nynf3Id?: string;
    /**
     * 
     * OpenAPI data type: {ProviderDentalClaim}
     * @type {ProviderDentalClaim}
     * @memberof ProviderClaimTransmission
     */
    nynf3?: ProviderDentalClaim;
    /**
     * The associated payments when used with a coordination of benefits.
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof ProviderClaimTransmission
     */
    paymentIds?: Array<string>;
    /**
     * The associated payments when used with a coordination of benefits.
     * OpenAPI data type: {array}
     * @type {Array<ProviderClaimPayment>}
     * @memberof ProviderClaimTransmission
     */
    payments?: Array<ProviderClaimPayment>;
    /**
     * The electronically transmitted document if the payer supports it
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimTransmission
     */
    documentId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderDocument}
     * @type {ProviderDocument}
     * @memberof ProviderClaimTransmission
     */
    document?: ProviderDocument;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderClaimTransmission
     */
    created?: string;
}

export function ProviderClaimTransmissionFromJSON(json: any): ProviderClaimTransmission {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
            'x12': !exists(json, 'x12') ? undefined : json['x12'],
            'statuses': !exists(json, 'statuses') ? undefined : (json['statuses'] as Array<any>).map(ClaimTransmissionStatusFromJSON),
            'type': !exists(json, 'type') ? undefined : TransmissionTypeFromJSON(json['type']),
            'payerIcn': !exists(json, 'payerIcn') ? undefined : json['payerIcn'],
            'clearinghousePayerId': !exists(json, 'clearinghousePayerId') ? undefined : json['clearinghousePayerId'],
            'payerSubscriberId': !exists(json, 'payerSubscriberId') ? undefined : json['payerSubscriberId'],
            'payerSubscriber': !exists(json, 'payerSubscriber') ? undefined : ProviderPayerSubscriberFromJSON(json['payerSubscriber']),
            'subscriberPatientId': !exists(json, 'subscriberPatientId') ? undefined : json['subscriberPatientId'],
            'subscriberPatient': !exists(json, 'subscriberPatient') ? undefined : ProviderSubscriberPatientFromJSON(json['subscriberPatient']),
            'professionalId': !exists(json, 'professionalId') ? undefined : json['professionalId'],
            'professional': !exists(json, 'professional') ? undefined : ProviderProfessionalClaimFromJSON(json['professional']),
            'institutionalId': !exists(json, 'institutionalId') ? undefined : json['institutionalId'],
            'institutional': !exists(json, 'institutional') ? undefined : ProviderInstitutionalClaimFromJSON(json['institutional']),
            'dentalId': !exists(json, 'dentalId') ? undefined : json['dentalId'],
            'dental': !exists(json, 'dental') ? undefined : ProviderDentalClaimFromJSON(json['dental']),
            'nynf3Id': !exists(json, 'nynf3Id') ? undefined : json['nynf3Id'],
            'nynf3': !exists(json, 'nynf3') ? undefined : ProviderDentalClaimFromJSON(json['nynf3']),
            'paymentIds': !exists(json, 'paymentIds') ? undefined : json['paymentIds'],
            'payments': !exists(json, 'payments') ? undefined : (json['payments'] as Array<any>).map(ProviderClaimPaymentFromJSON),
            'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
            'document': !exists(json, 'document') ? undefined : ProviderDocumentFromJSON(json['document']),
            'created': !exists(json, 'created') ? undefined : json['created'],
    };

}

export function ProviderClaimTransmissionToForm(value?: ProviderClaimTransmission): any {
    let jsonVal = ProviderClaimTransmissionToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderClaimTransmissionToJSON(value?: ProviderClaimTransmission): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'externalId': cleanupBlankValuesForBackend(value.externalId),
            'x12': cleanupBlankValuesForBackend(value.x12),
            'statuses': (value.statuses === undefined || value.statuses === null) ? undefined : (value.statuses as Array<any>).map(ClaimTransmissionStatusToJSON),
            'type': TransmissionTypeToJSON(value.type),
            'payerIcn': cleanupBlankValuesForBackend(value.payerIcn),
            'clearinghousePayerId': cleanupBlankValuesForBackend(value.clearinghousePayerId),
            'payerSubscriberId': cleanupBlankValuesForBackend(value.payerSubscriberId),
            'payerSubscriber': ProviderPayerSubscriberToJSON(value.payerSubscriber),
            'subscriberPatientId': cleanupBlankValuesForBackend(value.subscriberPatientId),
            'subscriberPatient': ProviderSubscriberPatientToJSON(value.subscriberPatient),
            'professionalId': cleanupBlankValuesForBackend(value.professionalId),
            'professional': ProviderProfessionalClaimToJSON(value.professional),
            'institutionalId': cleanupBlankValuesForBackend(value.institutionalId),
            'institutional': ProviderInstitutionalClaimToJSON(value.institutional),
            'dentalId': cleanupBlankValuesForBackend(value.dentalId),
            'dental': ProviderDentalClaimToJSON(value.dental),
            'nynf3Id': cleanupBlankValuesForBackend(value.nynf3Id),
            'nynf3': ProviderDentalClaimToJSON(value.nynf3),
            'paymentIds': cleanupBlankValuesForBackend(value.paymentIds),
            'payments': (value.payments === undefined || value.payments === null) ? undefined : (value.payments as Array<any>).map(ProviderClaimPaymentToJSON),
            'documentId': cleanupBlankValuesForBackend(value.documentId),
            'document': ProviderDocumentToJSON(value.document),
            'created': cleanupBlankValuesForBackend(value.created),
    };
}


